import React from 'react';
import DonateButton from './DonateButton';

const Hero: React.FC = () => {
  return (
    <section className="bg-card pt-20 pb-20">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-1/2 mb-10 lg:mb-0">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              Every Animal Deserves A{' '}
              <span className="text-primary">Pawsitive Future</span>
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Bridging the gap between pet owners and essential veterinary care through our innovative voucher program. We partner directly with communities to ensure no animal goes without the care they need.
            </p>
            <DonateButton
              label="Donate Today"
              className="btn-primary px-8 py-3 rounded-full font-medium"
              wrapperClassName="flex justify-center sm:justify-start"
            />
          </div>
          <div className="lg:w-1/2 lg:pl-12">
            <img src="/assets/hero.png" alt="Happy dog" className="rounded-xl max-w-md w-full" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;